import React from "react"
import { useTranslation } from "react-i18next"

import InlineLinkListItem from "@knowit-alma/common/src/components/atoms/InlineLinkListItem/InlineLinkListItem"

import styles from "./InfoBoxAlt.module.scss"

const InfoBoxAlt = ({ heading, list, link }) => {
  const { t } = useTranslation()

  const listFiltered = Array.isArray(list)
    ? list.map((item, i) => {
        return <li key={i}>{item}</li>
      })
    : []

  return (
    <section className={`${styles.element} make-full-width-on-mobile`}>
      <div className={styles.container}>
        <h2>{heading}</h2>
        {listFiltered.length > 0 && (
          <ul className={styles.list}>{listFiltered}</ul>
        )}
        {link && (
          <div className="base-margin-top-small">
            <InlineLinkListItem
              href={link.url}
              text={link.title ? link.title : t("Read more")}
              element="p"
              internal={link.target !== "_blank"}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default InfoBoxAlt
